import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import accountsLicenses from './accountsLicenses.json';
import styles from './DashboardFrontendLisenses.module.scss';

type Licence = {
    name: string;
    licenseType: string;
    link: string;
    installedVersion: string;
    author: string;
};
const AccountsLicenses = (): ReactElement => {
    const { t: txt } = useTranslation();
    const getUrl = (link: string): string => {
        const gitPrefix = 'git+';
        return link.startsWith(gitPrefix) ? link.substring(gitPrefix.length) : link;
    };

    return (
        <div>
            <h1>{txt('SwLicense.AccountsLicenseHeader')}</h1>
            <p>{txt('SwLicense.AccountsLicenseDescription')}</p>
            <div className={styles.wrapper}>
                {accountsLicenses.map((license: Licence) => (
                    <div key={license.name}>
                        <div className={styles.header}>{license.name}</div>
                        <div>
                            {txt('SwLicense.InstalledVersion')}: {license.installedVersion}
                        </div>
                        <div>
                            {txt('SwLicense.LicenseType')}: {license.licenseType}
                        </div>
                        <div>
                            {txt('SwLicense.License')}:{' '}
                            <a href={getUrl(license.link)} rel="noopener noreferrer" target="_blank">
                                {getUrl(license.link)}
                            </a>
                        </div>
                        <div>
                            {txt('SwLicense.Author')}: {license.author}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AccountsLicenses;
